import React, { useCallback, useState } from 'react';
import { node } from 'prop-types';
import { getUserBankAccount } from '@screens/Profile/fetcher';

export const BankContext = React.createContext();

const BankProvider = ({ children }) => {

  const [userBankProfile, setUserBankProfile] = useState({})
  const [isLoadingUserBankProfile, setIsLoadingUserBankProfile] = useState(false);

  const fetchUserBankProfile = useCallback((params) => {
    setIsLoadingUserBankProfile(true);
    getUserBankAccount(params)
      .then((response) => {
        setUserBankProfile(response?.results[0]);
        setIsLoadingUserBankProfile(false);
      })
      .catch((err) => {
        console.error(err);
        setUserBankProfile(err);
        setIsLoadingUserBankProfile(false);
      });
  }, [getUserBankAccount]);


  const valueProps = {
    userBankProfile,
    isLoadingUserBankProfile,
    fetchUserBankProfile
  };
  
  return <BankContext.Provider value={valueProps}>{children}</BankContext.Provider>;
};

BankProvider.propTypes = {
  children: node.isRequired,
};

export default BankProvider;